import { environment } from '@environments/environment';

export const API_VERSION = {
    v1: environment.API_URL + 'api/v1.0/',
    v2: environment.API_URL + 'api/v1.1/'
};
